import { configureStore, createSlice } from '@reduxjs/toolkit'


let cart = createSlice({
    name: 'cart',
    initialState: [
        { id: 0, name: '블라썸 스웨트셔츠 1718 아이보리', price: 57400, count: 1 }
    ],
    reducers: {
        addCount(state, action) {
            let num = state.findIndex((a) => { return a.id === action.payload })
            state[num].count++
        },
        miCount(state, action) {
            let num = state.findIndex((a) => { return a.id === action.payload })
            state[num].count--
            if (state[num].count < 1) {
                state[num].count = 1;
                alert("최소 수량입니다.")
            }
        },
        addItem(state, action) {
            if (action.payload.type === 'addObj') {
                let num = state.findIndex(a => a.id === action.payload.id)
                if (num >= 0) {
                    state[num].count++;
                } else {
                    state.push(action.payload);
                }
            } else {
                return state.push(action.payload)
            }
        },
        sortName(state, action) {
            state.sort((a, b) =>
                a.name > b.name ? 1 : -1);
        },
        removeItem(state, action) {
            // state.pop(action.payload)
            let num = state.findIndex(a => a.id === action.payload)
            state.splice(num, 1)
        }
    }
})

export let { addCount, miCount, addItem, sortName, removeItem } = cart.actions
export default configureStore({
    reducer: {
        cart: cart.reducer
    }
})